module.exports = __webpack_public_path__ + "static/media/sharecard-slide-diy.2b27824a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sharecard-slide-diy.png
// module id = 2127
// module chunks = 6